import React, { useState } from 'react';
import Footer from '../components/Footer';

const Contact = () => {
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [address, setAddress] = useState('');
  const [date, setDate] = useState('');

  // Function to handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // Create the message to be sent through WhatsApp
    const whatsappMessage = `Hello, I am ${name}. My contact is ${contact}. My address is: ${address}. Here is the query date: ${date}`;
    // Encode the message properly
    const encodedMessage = encodeURIComponent(whatsappMessage);
    // Redirect to WhatsApp with the encoded message
    window.open(`https://wa.me/918052636431?text=${encodedMessage}`, '_blank');
  };

  return (
    <>
      <div className="container mt-5">
        <h2>Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Name
            </label>
            <input
              type="text"
              className="form-control"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="contact" className="form-label">
              Contact
            </label>
            <input
              type="text"
              className="form-control"
              id="contact"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="address" className="form-label">
              Address
            </label>
            <textarea
              className="form-control"
              id="address"
              rows="4"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
            ></textarea>
          </div>
          <div className="mb-3">
            <label htmlFor="date" className="form-label">
              Date
            </label>
            <input
              type="date"
              className="form-control"
              id="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </form>
      </div>

      <br/>
      
      <Footer />
    </>
  );
};

export default Contact;
